module.exports = __webpack_public_path__ + "static/ShapeFoto-adf5d80937be37177efa0b8fe532fa49.png";